import React from 'react'
import SyncButton from '../../ui/sync-button'

const PersonnelSyncButton = ({provider_registration_id, onComplete }) => (
  <SyncButton
    compact
    right
    steps={[
      {
        syncPath: '/api/provider-registrations/' + provider_registration_id + '/sync-personnel',
        text: 'Updating CCS Personnel Records',
      },
      {
        syncPath: '/api/provider-registrations/' + provider_registration_id + '/sync-care-personnel',
        text: 'Updating Xplor Personnel Records',
      }
    ]}
    onComplete={onComplete}
  />
)

export default PersonnelSyncButton



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/sync-button.jsx